export enum ResponseStatusMessage {
  ERROR_IDP = 'error-idp',
  SUCCESS_PASSWORD_RESET = 'success-password-reset',
  SUCCESS_REGISTRATION = 'success-registration',
}
